import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const EditButton = styled(Button)(({ theme }) => ({
  background: "#0B0B0B",
  border: "1px solid #858585",
  borderRadius: "4px",
  padding: "6px 10px",
  minWidth: "fit-content",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "16px",
  color: "#fff",
  textTransform: "capitalize",
  fontFamily: theme.typography.fontFamily,
  borderRadius: "40px",
  "&:hover": {
    background: "#0B0B0B",
    color: "#fff",
  },
}));

export { EditButton };
